import React, { useState, useEffect } from "react";
import ThreeDCarousel from "./ThreeDCarousel";
import Carpet001 from '../../../assets/images/New-Arrivel/Carpet-23.jpg';
import Carpet002 from '../../../assets/images/New-Arrivel/Carpet-24.jpg';
import Carpet003 from '../../../assets/images/New-Arrivel/Carpet-25.jpg';
import Carpet004 from '../../../assets/images/New-Arrivel/Carpet-26.jpg';
import Carpet005 from '../../../assets/images/New-Arrivel/Carpet-24.jpg';


function FreshArrivals() {
     const [loading, setLoading] = useState(true);
     useEffect(() => {
        setLoading(false);
      }, []);

      // Hide section if no API data
      if (!loading && FreshArrivals.length === 0) {
        return null;
      }

  return (
    <div className="container wow animate__animated animate__fadeInRight mt-5">
      <div className="row"> 
         <div className="col-md-12 text-center">
                <h2 className="text-lg text-gray-500 text-center font-small mb-2" style={{ fontSize:"28px", fontWeight:"400", fontFamily: "Roboto, sans-serif" }}> NEW ARRIVAL </h2>
                <div style={{ height:"3px", width:"40px", backgroundColor:"#727171", margin: "14px auto" }}> </div>
         </div>
      </div>
      <ThreeDCarousel images={[Carpet001, Carpet002, Carpet003, Carpet004, Carpet005]} />
    </div>
  );
}
export default FreshArrivals;